import { render, staticRenderFns } from "./DebitNotePreview.vue?vue&type=template&id=23bb1f26&scoped=true&"
import script from "./DebitNotePreview.vue?vue&type=script&lang=js&"
export * from "./DebitNotePreview.vue?vue&type=script&lang=js&"
import style0 from "./DebitNotePreview.vue?vue&type=style&index=0&id=23bb1f26&lang=scss&scoped=true&"
import style1 from "./DebitNotePreview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bb1f26",
  null
  
)

export default component.exports